import deepmerge from 'deepmerge';
import warning from 'warning';
import {color, focusRing, typography} from '@/uptk/core/packages/style/index';
// import { SpectrumLoader } from '../../../../packages/spectrum-loader'
import React from 'react'
import {primary} from "glamor/ous";
// import '~@i_yomi_i/spectrum-bootstrap/scss/_spectrum-color-palette'

const dark = {
    type: 'dark',
    background: {
        contentFrame: color.black,
        default: '#002858',
        paper: '#0C3566'
    },
    text: {
        primary: color.white,
        contrast: color.grey900
    },
    typography,
    color1: "#46d68d",
    color2: '#FFFFFF',
    color3: "#ef3341",
    borderColor: color.grey200
};

const light = {
    type: 'light',
    background: {
        contentFrame: color.white,
        default: '#f9fafb',
        paper: '#ffffff'
    },
    text: {
        primary: color.white,
        contrast: color.white
    },
    typography,
    color1: "#46d68d",
    color2: "#1F1F2F",
    color3: "#ef3341",
    borderColor: color.grey70
};

export const palettes = {
    dark,
    light
};

const defaultColorValueMapper = ({
    value
}: any) => value;

const mapColor = (activeColor: any, colorMapper: any, type: any) =>
    Object.keys(activeColor).reduce((colorMap, name) => {
        colorMap[name] = colorMapper({
            name,
            type,
            value: activeColor[name]
        });
        return colorMap;
    }, {});

export const getPalettes = (type: any, env: any, envTheme: any) => {

    if (
        envTheme != undefined &&
        envTheme["color-primary"] != undefined
    ) {
        palettes[type].id = type;
        palettes[type].color1 = envTheme["color-primary"];
        palettes[type].color2 = envTheme["color-primary-light"];
        palettes[type].color3 = envTheme["color-primary-dark"];
        palettes[type].primary = { main: envTheme["color-primary"] };
        palettes[type].primaryLight = envTheme["color-primary-light"];
        palettes[type].primaryDark = envTheme["color-primary-dark"];
    }

    return palettes[type];
};

export const createPalette = (
    type = 'light',
    env = 'prod',
    envTheme = {},
    colorMapper = defaultColorValueMapper,
    options = {}
) => {
    if (import.meta.env.DEV) {
        warning(
            Object.prototype.hasOwnProperty.call(palettes, type),
            `UI-Toolkit: the palette type \`${type}\` is not supported,
        should be one of ${Object.keys(palettes)}`
        );
    }

    const _updatePalettes = getPalettes(type, env, envTheme);

    const rtnPalettes = deepmerge(
        {
            ..._updatePalettes,
            focusRing,
            toolkit: {
                    ...mapColor(color, colorMapper, type)
            },
            envTheme
        },
        options,
        {clone: false}
    );

    return rtnPalettes;
};
